<template>

    <div>


        <div id="app" :class="{ 'bloc-scroll': maintenance }">

            <header-left>

                <router-view class="app"/>

            </header-left>

            <maintenance :maintenance="maintenance"></maintenance>

            <cookie-law></cookie-law>

        </div>

        <metas></metas>

        <structured-data></structured-data>

        <check-offline></check-offline>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import Storage from '@/helpers/storage'

    import I18n from '@/modules/i18n'
    import Tag from '@/modules/tag'

    import CheckOffline from '@/components/CheckOffline'
    import CookieLaw from '@/components/CookieLaw'
    import HeaderLeft from '@/components/headers/HeaderLeft'
    import Maintenance from '@/components/Maintenance'
    import Metas from '@/components/Metas'
    import StructuredData from '@/components/StructuredData.vue'

    export default {

        components: { CheckOffline, CookieLaw, HeaderLeft, Maintenance, Metas, StructuredData },

        computed: {

            ...Vuex.mapGetters(['maintenance'])

        },

        created() {

            I18n.created(this)

            // waiting for V2, initTracking in app.js
            Tag.initTracking(this)

            try {
                document.getElementById('app-speed-index').remove()
            } catch (ignored) {
                // do nothing
            }

        },

        mounted() {

            window.scrollTo(0, 1)

            if(Storage.getItem('obvCookie')) {

                Tag.initTracking(this)

            }

        }
    }

</script>

<style lang="scss" src="./style/main.scss"></style>

<style scoped lang="scss">

    .app {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .bloc-scroll {
        height: 100vh;
        overflow: hidden;
    }

</style>

